import React from 'react';
import ComponentHeader from '../ComponentHeader';
import { FormHelperText } from '@mui/material';

const HyperLink = (props) => {
	const { data, style } = props;

	let baseClasses = 'SortableItem rfb-item';
	if (data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}

	let fieldName = data?.field_name || `${data.group_name}_${data.id.toLowerCase()}`;

	return (
		<div name={fieldName.toLowerCase()} style={{ ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<div className={`form-group${props.isChanged ? ' isChanged' : ''}`}>
				<a
					target="_blank"
					href={data.href}
					rel="noreferrer"
					dangerouslySetInnerHTML={{ __html: data.content }}
				/>
				<FormHelperText error={data?.error}>{data?.help_message}</FormHelperText>
			</div>
		</div>
	);
};

export default HyperLink;
